import { FC } from 'react';
import './BonusMenuItem.scss';
import { arrowMenu } from '../../../../assets';
import { BonusMenuItemProps } from './types';
import { useNavigate } from 'react-router';

const BonusMenuItem: FC<BonusMenuItemProps> = ({ icon, title, onClick, page }) => {
    const navigate = useNavigate();
    return (
        <div
            className="bonus-menu-item"
            onClick={onClick}>
            <div className="bonus-menu-item__title">
                <img
                    src={icon}
                    alt=""
                />
                <h2>{title}</h2>
            </div>
            <img
                src={arrowMenu}
                alt=""
            />
        </div>
    );
};

export default BonusMenuItem;
